module.exports = __webpack_public_path__ + "img/grumier.4cd91719.jpg";